"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLIER_CONFIG_CREATE = void 0;
exports.SUPPLIER_CONFIG_CREATE = {
    INVALID_REPLICATION: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_REPLICATION",
        messageLangMap: {
            "PT-BR": "Não é possível replicar um fornecedor integrado.",
        },
    },
    INVALID_PAY_OPTION_FOR_SAME_SERVICE_TYPE: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_PAY_OPTION_FOR_SAME_SERVICE_TYPE",
        messageLangMap: {
            "PT-BR": "Fornecedores integrados do mesmo tipo de serviço não podem ter formas de pagamento diferentes.",
        },
    },
    INVALID_MONETIZATION_LOCATION: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_MONETIZATION",
        messageLangMap: {
            "PT-BR": "Não é possível configurar monetização pela agência nesse fornecedor.",
        },
    },
    INVALID_MONETIZATION_CONFIG: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_MONETIZATION_CONFIG",
        messageLangMap: {
            "PT-BR": "Configuração de monetização inválida.",
        },
    },
    INVALID_AGENCY_RECEIPT_OPTION: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_AGENCY_RECEIPT_OPTION",
        messageLangMap: {
            "PT-BR": "Opção de recebimento da agência inválida.",
        },
    },
    INVALID_SUPPLIER_RECEIPT_OPTION: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_SUPPLIER_RECEIPT_OPTION",
        messageLangMap: {
            "PT-BR": "Opção de recebimento do fornecedor inválida.",
        },
    },
    ALREADY_REGISTERED: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "ALREADY_REGISTERED",
        messageLangMap: {
            "PT-BR": "Fornecedor já configurado.",
        },
    },
    INVALID_MANDATORY_FIELDS: {
        usecase: "SUPPLIER_CONFIG_CREATE",
        type: "INVALID_MANDATORY_FIELDS",
        messageLangMap: {
            "PT-BR": "Campos obrigatório(s) não preenchido(s) para esse fornecedor.",
        },
    }
};
